module.exports = __webpack_public_path__ + "img/2_12.357f78a0.png";